import { createEnv } from './env/env';
import { Config } from './types';

const createConfig = (): Config => {
  const env = createEnv();
  return {
    env: env.REACT_APP_DEPLOYMENT_ENV,
    release: env.REACT_APP_OC_RELEASE,
    stage: env.REACT_APP_OC_STAGE,
    brandName: env.REACT_APP_BRAND_NAME,
    experienceUrl: env.REACT_APP_EXPERIENCE_URL,
    isLiteVersion: env.REACT_APP_IS_LITE_VERSION,
    integrationGuideUrl: env.REACT_APP_INTEGRATION_GUIDE_URL,

    sentry: env.REACT_APP_OC_SENTRY_DSN,
    activityLogPollingInterval: env.REACT_APP_ACTIVITY_LOG_POLLING_INTERVAL,

    api: {
      host: env.REACT_APP_API_HOST,
      docUrl: env.REACT_APP_API_DOC_URL,
      commandKey: env.REACT_APP_COMMAND_API_KEY,
      commandUrl: env.REACT_APP_COMMAND_API_URL,
      commandWsUrl: env.REACT_APP_COMMAND_API_WS_URL,
    },

    google: {
      mapsApiKey: env.REACT_APP_OC_GOOGLE_MAPS_API_KEY,
      analyticsId: env.REACT_APP_GOOGLE_ANALYTICS_ID,
    },

    communicationPreference: {
      enabled: env.REACT_APP_CONFIG_COMMUNICATION_PREFERENCE_ENABLED,
      optInConfigurable: {
        sms: env.REACT_APP_CONFIG_COMMUNICATION_PREFERENCE_SMS_OPT_IN_CONFIGURABLE,
        email: env.REACT_APP_CONFIG_COMMUNICATION_PREFERENCE_EMAIL_OPT_IN_CONFIGURABLE,
        push: env.REACT_APP_CONFIG_COMMUNICATION_PREFERENCE_PUSH_OPT_IN_CONFIGURABLE,
      },
    },

    retailerConnect: {
      enabled: env.REACT_APP_RETAILER_CONNECT_ENABLED,
      networkManagementEnabled: env.REACT_APP_RETAILER_CONNECT_NETWORK_MANAGEMENT_ENABLED,
      addExistingUserEnabled: env.REACT_APP_RETAILER_CONNECT_NETWORK_ADD_EXISTING_USER_ENABLED,
    },

    storedValue: {
      enabled: env.REACT_APP_STORED_VALUE_ENABLED,
    },

    features: {
      walletSteeringEnabled: env.REACT_APP_WALLET_STEERING_ENABLED,
      scanDataTabEnabled: env.REACT_APP_SITE_MANAGEMENT_SCAN_DATA_TAB_ENABLED,
      promptAtPumpEnabled: env.REACT_APP_PROMPT_AT_PUMP_ENABLED,
      mpaSimulatorEnabled: env.REACT_APP_CONFIG_LOCATION_DETAILS_MPA_SIMULATOR_ENABLED,
      messagingCenterEnabled: env.REACT_APP_MESSAGING_CENTER_ENABLED,
      externalBannersEnabled: env.REACT_APP_EXTERNAL_BANNERS_ENABLED,
      promocodesOffersEnabled: env.REACT_APP_PROMOCODES_OFFERS_ENABLED,
      mobileTransactionsEnabled: env.REACT_APP_MOBILE_TRANSACTIONS_ENABLED,
      deleteMemberEnabled: env.REACT_APP_DELETE_MEMBER_ENABLED,
      deleteMemberAction: env.REACT_APP_DELETE_MEMBER_ACTION,
    },
  };
};

export const config = createConfig();
